@use '../../scss/global' as *;
@use '../../scss/components/form-element.mixins' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-text-area {

    // ==== Shared Form Element Styles

    @include form-group();
    @include form-container();
    @include form-element-placeholder();
    @include form-element-cancel-button($position-styles: false);
    @include focus-indicator();

    // ==== Container

    .form-container {
      padding-right: 0;

      // == CancelInput Button Offset

      &.has-value {
        &.allow-cancel {
          padding-right: 0;

          .text-area-input {
            padding-right: calc(var(--G-form-element-button-offset) + var(--G-form-element-button-size));
          }
        }
      }
    }

    // ==== Textarea Element

    .text-area-input {
      @include input-reset;
      width: 100%;
      min-height: calc(var(--G-form-element-height) - (var(--G-border-width) * 2));
      line-height: var(--textarea-line-height);
      padding-top: var(--form-element-padding-top); // Generated by form-element-padding-vars()
      padding-bottom: var(--form-element-padding-bottom); // Generated by form-element-padding-vars()
      padding-right: var(--G-form-element-padding-right);
      border-top-right-radius: calc(var(--G-border-radius) + 1px);
      border-bottom-right-radius: calc(var(--G-border-radius) + 1px);
      resize: vertical;
      -ms-overflow-style: none;

      // == Native CSS "autoResize"

      &.auto-resize {
        field-sizing: content;
      }

      // == Disabled / Read-Only

      &.disabled,
      &.read-only {
        resize: none;
      }
    }

    // ==== CancelInput Button

    .cancel {
      position: absolute;
      top: calc(
        ((var(--G-form-element-height) - var(--G-form-element-button-size)) / 2) - var(--G-border-width)
      );
      right: var(--G-form-element-button-offset);
    }
  }
}
